import * as actionTypes from '@actions/actionTypes';
import urls from '@constants/urls';
import responseStatus from '@constants/responseStatuses';
import {GetAuthenticatedUser} from '@graphql/user/query';
import {broadcastDone} from '@modules/app/utils/authenticateUtils';
import {CreateErrorLog} from '@graphql/errorLog/mutation';

import apolloClient from '../apolloClient';

export const reportError = (data) => {
    const {
        url = 'Not set',
        previousRoute = 'Not set',
        error = 'Not set',
        user,
        timezone,
    } = data;

    const body = `
        URL: ${url} <br/>
        Previous URL: ${previousRoute} <br/>
        Error:\n ${error} <br/>
        User: ${user?.name} (ID ${user?.id}) <br/>
        Timezone: ${timezone.timezone} <br/>
        Autodetected_timezone: ${timezone.autodetected_timezone}
    `;

    if ('avcmp.sportradar.com' !== window.location.host || !user)
    {
        return;
    }

    apolloClient.mutate({
        mutation: CreateErrorLog,
        variables: {
            data: body,
        },
    });
};

export const authenticationCheck = () => {
    return {
        type: actionTypes.AUTHENTICATION_CHECK,
    };
};

export const saveMessage = (data) => {
    return {
        type: actionTypes.SAVE_MESSAGE_BOX,
        data: data,
    };
};

export const clearMessage = (data) => {
    return {
        type: actionTypes.CLEAR_MESSAGE_BOX,
        data: data,
    };
};

export const setClosedTimestamp = (data) => ({
    data: data,
    type: actionTypes.SET_CLOSED_TIMESTAMP,
});

export const authenticationFailure = () => {
    return {
        type: actionTypes.AUTHENTICATION_FAILURE,
    };
};

export const saveUser = (userData) => {
    return {
        type: actionTypes.SAVE_USER,
        data: userData,
    };
};

export const fetchAuthenticationFailure = (errorMessage) => {
    return {
        type: actionTypes.FETCH_AUTHENTICATION_FAILURE,
        errorMessage: errorMessage,
    };
};

export const authenticationSuccess = () => {
    return {
        type: actionTypes.AUTHENTICATION_SUCCESS,
    };
};

export const setFilter = (params = {}) => {
    return {
        type: actionTypes.SET_FILTER,
        data: params,
    };
};

export const setInitialFilter = (params = {}) => {
    return {
        type: actionTypes.SET_INITIAL_FILTER,
        data: params,
    };
};

export const resetFilter = (name) => {
    return {
        type: actionTypes.RESET_FILTER,
        data: name,
    };
};

export const toggleFiltersVisibility = (key = {}) => {
    return {
        type: actionTypes.FILTERS_VISIBILITY,
        data: key,
    };
};

export const sessionEnd = () => ({type: actionTypes.SESSION_END});

export const setModal = (params = {}) => {
    return {
        type: actionTypes.SET_MODAL,
        data: params,
    };
};

export const setModalConfirmation = (params = {}) => {
    return {
        type: actionTypes.SET_MODAL_CONFIRMATION,
        data: params,
    };
};

export const setModalError = (params = {}) => {
    return {
        type: actionTypes.SET_MODAL_ERROR,
        data: params,
    };
};

export function validateAuthentication() {
    return async function (dispatch) {
        dispatch(authenticationCheck());

        try {
            const response = await fetch(urls.authValidate, {
                cache: 'no-cache',
                credentials: 'include',
            });

            if (responseStatus.HTTP_OK !== response.status) {
                throw new Error('Bad response from server');
            }

            const json = await response.json();

            if (!json.is_authenticated) {
                dispatch(authenticationFailure());

                return false;
            }

            try {
                const gqlResponse = await apolloClient.query({
                    query: GetAuthenticatedUser,
                    fetchPolicy: 'network-only',
                });
                const authenticatedUser = gqlResponse.data.authenticatedUser;

                dispatch(saveUser(authenticatedUser));
                dispatch(authenticationSuccess());
                broadcastDone(authenticatedUser);

                return true;
            } catch (error) {
                /* eslint-disable-next-line no-console */
                console.error('Authentication error', error);
                dispatch(fetchAuthenticationFailure('Authentication error: ' + error.toString()));

                return false;
            }
        } catch (error) {
            /* eslint-disable-next-line no-console */
            console.error('Authentication validation error', error);
            dispatch(fetchAuthenticationFailure('Authentication validation error: ' + error.toString()));

            return false;
        }
    };
}


export const storeEntity = (entity = {}) => {
    return {
        type: actionTypes.ENTITY_STORE,
        data: entity,
    };
};

export const removeEntity = (name) => {
    return {
        type: actionTypes.ENTITY_REMOVE,
        name: name,
    };
};

export const storeMenu = (key) => {
    return {
        type: actionTypes.MENU_STORE,
        key: key,
    };
};

export const saveMenu = (key) => {
    return {
        type: actionTypes.MENU_SAVE,
        key: key,
    };
};

export const toggleSidebar = (key) => {
    return {
        type: actionTypes.MENU_TOGGLE,
        key: key,
    };
};

export const setTimezone = (timezone) => {
    return {
        type: actionTypes.SET_TIMEZONE,
        data: timezone,
    };
};

export const setRedirectLoaderVisibility = (params = {}) => {
    return {
        type: actionTypes.SET_REDIRECT_LOADER_VISIBILITY,
        params,
    };
};

export const setScrollPosition = (params = {}) => {
    return {
        type: actionTypes.SET_SCROLL,
        params,
    };
};

export const setTableParamsToStore = (params) => {
    return {
        type: actionTypes.SET_TABLE_PARAMS,
        params,
    };
};

export const toggleStreamPlaybackDebugMode = () => ({type: actionTypes.TOGGLE_STREAM_PLAYBACK_DEBUG_MODE});

export const toggleYunaiOutputMode = () => ({type: actionTypes.TOGGLE_YUNAI_OUTPUT_MODE});
